var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHhInnerBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 497.141,
    height: 373.121
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 407",
    d: "M476.997 312.669V130.947c0-25.7 1.51-43.833 20.144-59.955h-93.7c18.644 16.122 20.156 34.259 20.156 59.955v37.133h-53.088V59.957c0-25.7 1.51-43.835 20.144-59.957h-93.7c18.646 16.122 20.156 34.259 20.156 59.957V168.08H180.042V59.957c0-25.7 1.507-43.835 20.156-59.957h-93.711c18.643 16.122 20.153 34.259 20.153 59.957V168.08H73.555v-37.133c0-25.7 1.507-43.833 20.156-59.955H0c18.643 16.122 20.153 34.259 20.153 59.955v181.722c0 25.692-1.51 43.826-20.153 60.448h93.711c-18.649-16.618-20.156-34.748-20.156-60.448v-105.29h53.085v105.29c0 25.692-1.51 43.826-20.153 60.448h93.711c-18.649-16.618-20.156-34.748-20.156-60.448v-105.29h137.066v105.29c0 25.692-1.51 43.826-20.156 60.448h93.7c-18.632-16.618-20.143-34.748-20.143-60.448v-105.29h53.086v105.29c0 25.692-1.512 43.826-20.156 60.448h93.7c-18.632-16.618-20.142-34.748-20.142-60.448z",
    fill: "#555658",
    opacity: 0.128
  })));
}

export default __webpack_public_path__ + "b254e9566dca025ca5933be7a696f526.svg";
export { SvgHhInnerBg as ReactComponent };